export default ({ schedulerReact }) => ({
  weekly: {},
  buttons: {
    marginBottom: 20
  },
  button: {

    padding: [10, 15],
    ...schedulerReact.weeklyButtons,
    '&:disabled': {
      backgroundColor: schedulerReact.disabledBackgroundColor,
      borderColor: schedulerReact.disabledBorderColor,
      color: schedulerReact.disabledTextColor
    }
  },
  active: {
    ...schedulerReact.weeklyActiveButtons
  }
});
